import ReactDOM from 'react-dom';
import { Popover } from 'mag-react-components';

function popupContent({
  HH_blw4p80AMI,
  HH_blw4p50AMI,
  TOTAL_HH_FOR_INCOME,
  MEDIAN_HOUSEHOLD_INCOME,
  juris,
}) {
  const popupDom = document.createElement('div');
  if (!HH_blw4p80AMI) {
    ReactDOM.render(
      <>
        <div>
          The household income for this location is not available. Please try
          another address.
        </div>
      </>,
      popupDom
    );
    return popupDom;
  }
  const HHvw4p50AMIPct = HH_blw4p50AMI / TOTAL_HH_FOR_INCOME;
  const HHvw4p80AMIPct = HH_blw4p80AMI / TOTAL_HH_FOR_INCOME;
  ReactDOM.render(
    <>
      <div style={{ float: 'right' }}>
        <Popover
          title="AMI Help"
          definition="The 80% Area Median Income (AMI) used for this analysis is the 4 person annual value calculated for FY2021."
        />
      </div>
      {juris ? (
        <p>
          City/Town: <b>{juris}</b>
        </p>
      ) : (
        ''
      )}

      <div>
        {HHvw4p50AMIPct >= 0.6 ? (
          <span>
            ✔️ This <b>IS</b> an area with an 60%+ majority of households below
            50% AMI ($39,500)
          </span>
        ) : (
          <span>
            ❌ This <b>IS NOT</b> an area with an 60%+ majority of households
            below 50% AMI ($39,500)
          </span>
        )}
        <br />
        <br />
        {HHvw4p80AMIPct >= 0.6 ? (
          <span>
            ✔️ This <b>IS</b> an area with an 60%+ majority of households below
            80% AMI ($63,500)
          </span>
        ) : (
          <span>
            ❌ This <b>IS NOT</b> an area with an 60%+ majority of households
            below 80% AMI ($63,500)
          </span>
        )}
      </div>
      <br />
      <p>
        Total Households: <b>{TOTAL_HH_FOR_INCOME.toLocaleString()}</b>
      </p>
    </>,
    popupDom
  );

  return popupDom;
}
export default popupContent;
